import { render } from "./UploadImage.vue?vue&type=template&id=509a0e64"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"

import "./UploadImage.vue?vue&type=style&index=0&id=509a0e64&lang=css"

import exportComponent from "/buddy/vue-imprint-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__